import { Session } from 'next-auth';
import { useEffect, useState } from 'react';

import { getSession } from './session-actions';

export function useSession() {
  const [session, setSession] = useState<Session>();

  useEffect(() => {
    getSession().then((s) => setSession(s ?? undefined));
  }, []);

  return session;
}
